<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <el-table :data="withdrawalCfgs" resource="withdrawal-cfgs">
      <el-table-column prop="id" label="ID" width="60" />
      <el-table-column prop="channelTypeText" label="提现方式" />
      <el-table-column prop="fee_rate" label="手续费率" />
      <el-table-column prop="base_amount" label="起提金额" />
      <el-table-column prop="multiple" label="提现倍数" />
      <el-table-column prop="upper_limit" label="提现上限" />
      <el-table-column label="操作" width="150">
        <template #default="{ row, $index }">
          <el-button-group>
            <row-to-edit />
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <div class="card-footer">
      <pagination :page="page" />
    </div>
  </el-card>
</template>

<script>
import SearchForm from '@c/SearchForm'
import Pagination from '@c/Pagination'
import { getWithdrawalCfgs } from '@/api/withdrawal-cfgs'
import RowDestroy from '@c/LzTable/RowDestroy'
import RowToEdit from '@c/LzTable/RowToEdit'

export default {
  name: 'Index',
  components: {
    RowToEdit,
    RowDestroy,
    SearchForm,
    Pagination,
  },
  data() {
    return {
      search: [
        {
          field: 'id',
          label: 'ID',
        },
        {
          field: 'field_name',
          label: '字段名',
        },
      ],
      withdrawalCfgs: [],
      page: null,
    }
  },
  watch: {
    $route: {
      async handler(newVal) {
        const { data: { data, meta } } = await getWithdrawalCfgs(newVal.query)
        this.withdrawalCfgs = data
        this.page = meta
      },
      immediate: true,
    },
  },
}
</script>
